// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"b6b1eee6","990":"9092dd27"}[chunkId] + ".chunk.js";
};